/**
 * Owner: Masa Bayu
 * File: global-taxonomy-seed.ts
 * Date:Time: 2026-09-18 12:15
 * Description: Tier-1 CORE topic seed — canonical IDs · en labels (Global Topic Principle).
 */
/** Owner Tier-1 CORE topics — IDs stable; labels locale-extendable. */
export const QXREAD_TIER1_TOPIC_SEED = Object.freeze([
    tier1('arts_culture', 'Arts & Culture'),
    tier1('business_economics', 'Business & Economics'),
    tier1('education', 'Education'),
    tier1('engineering_technology', 'Engineering & Technology'),
    tier1('health_wellness', 'Health & Wellness'),
    tier1('history_civilization', 'History & Civilization'),
    tier1('law_governance', 'Law & Governance'),
    tier1('lifestyle', 'Lifestyle'),
    tier1('literature_fiction', 'Literature & Fiction'),
    tier1('mathematics_science', 'Mathematics & Science'),
    tier1('philosophy_thought', 'Philosophy & Thought'),
    tier1('religion_spirituality', 'Religion & Spirituality'),
    tier1('social_sciences', 'Social Sciences'),
    tier1('sports_recreation', 'Sports & Recreation'),
    tier1('travel_places', 'Travel & Places'),
    tier1('children_family', 'Children & Family'),
    tier1('food_cooking', 'Food & Cooking'),
    tier1('hobbies_crafts', 'Hobbies & Crafts'),
    tier1('news_current_affairs', 'News & Current Affairs'),
    tier1('professional_career', 'Professional & Career'),
    tier1('reference', 'Reference'),
    tier1('other_emerging', 'Other / Emerging'),
]);
function tier1(topicId, en) {
    return Object.freeze({
        topicId,
        parentId: null,
        tier: 1,
        status: 'core',
        labels: Object.freeze({ en }),
    });
}
//# sourceMappingURL=global-taxonomy-seed.js.map